export type AcneGradeValue = string | null

export interface AcneGradeOption {
    key: string
    label: string
    inflammation: string
    subtype: string
    tooltip: string
}

export const ACNE_GRADE_OPTIONS: AcneGradeOption[] = [
    {
        key: 'I',
        label: 'Grau I',
        inflammation: 'Não-inflamatória',
        subtype: 'Comedogênica',
        tooltip: 'Predomínio de comedões abertos (pontos pretos) e fechados (pontos brancos), sem lesões inflamatórias significativas.',
    },
    {
        key: 'II',
        label: 'Grau II',
        inflammation: 'Inflamatória',
        subtype: 'Pápulo-pustulosa',
        tooltip: 'Pápulas e pústulas inflamatórias associadas aos comedões, geralmente na face.',
    },
    {
        key: 'III',
        label: 'Grau III',
        inflammation: 'Inflamatória',
        subtype: 'Nódulo-cística',
        tooltip: 'Nódulos e cistos dolorosos além de pápulas e pústulas, com maior risco de cicatrizes.',
    },
    {
        key: 'IV',
        label: 'Grau IV',
        inflammation: 'Inflamatória',
        subtype: 'Conglobata',
        tooltip: 'Forma grave e crônica, com nódulos, abscessos e fístulas interligados, deixando cicatrizes extensas.',
    },
    {
        key: 'V',
        label: 'Grau V',
        inflammation: 'Inflamatória',
        subtype: 'Fulminans',
        tooltip: 'Forma mais grave e rara, de início abrupto, com ulcerações necróticas e sintomas sistêmicos (febre, mal-estar).',
    },
]

export function findAcneGradeOption(key: AcneGradeValue): AcneGradeOption | null {
    return ACNE_GRADE_OPTIONS.find((option) => option.key === key) ?? null
}

export function isAcneGradeValueEmpty(value: AcneGradeValue | undefined): boolean {
    return !value
}
